<template>
  <sea-page title="Lista Documenti" header="Documenti">
    <documenti-ricevuti></documenti-ricevuti>
  </sea-page>
</template>

<script>
import DocumentiRicevuti from './DocumentiRicevuti.vue';
export default {
  components: {
    DocumentiRicevuti,

  },
  data() {
    return {};
  },
};
</script>

<style>
/** */
</style>
